import React from 'react';
import { Stack, styled, Typography, Box, IconButton, InputAdornment } from '@mui/material';
import { StyledParams } from 'types/common';
import { SubmitButton } from 'app/components/elements/SubmitButton';
import { InputText } from 'app/components/elements/InputText';
import { useHomePage } from 'app/pages/HomePage/hooks';
import { StatusFileFilter, widthScreen } from 'const/common';
import FilterModal from 'app/components/elements/ModalFilter';
import { Helmet } from 'react-helmet-async';
import { TableInfiniteScroll } from 'app/components/elements/TableInfiniteScroll';
import {
  defaultHeadersClose,
  headerTableFile,
  infoStickies,
  renderDataCloseFileTable,
  renderDataMapFileTable
} from 'const/table';
import { ButtonFilter } from 'app/components/elements/ButtonFilter';
import { DialogConfirm } from '../../components/elements/DialogConfirm';
function HomePage() {
  const {
    open,
    search,
    searchInput,
    selectedStatus,
    rows,
    setSearch,
    handleOpen,
    handleClose,
    handleCancel,
    handleInputSearch,
    handleStatusChange,
    handleClickRow,
    onFilter,
    handleResetFilter,
    formValue,
    fetchMoreData,
    hasMore,
    onSortHeader,
    closeFileData,
    fetchMoreCloseFileData,
    onDeleteCloseFile,
    setFileCloseDelete,
    fileCloseDelete,
    setReason
  } = useHomePage();

  return (
    <Stack width={'100%'}>
      <Helmet>
        <title>Surrey Bailiffs - Home</title>
      </Helmet>
      <Box mx={2}>
        <TitleStyled>All Files</TitleStyled>
        <Stack direction={'row'} mt={2.5} justifyContent={'space-between'}>
          <Stack direction={'row'} gap={1.25} flexWrap={'wrap'}>
            <ButtonCustom
              defaultValue={selectedStatus}
              active={selectedStatus === StatusFileFilter.OPEN_FILE ? 'active' : ''}
              onClick={() => handleStatusChange(StatusFileFilter.OPEN_FILE)}>
              Active Files
            </ButtonCustom>
            <ButtonCustom
              defaultValue={selectedStatus}
              active={selectedStatus === StatusFileFilter.ON_HOLD ? 'active' : ''}
              onClick={() => handleStatusChange(StatusFileFilter.ON_HOLD)}>
              On Hold
            </ButtonCustom>
            <ButtonCustom
              defaultValue={selectedStatus}
              active={selectedStatus === StatusFileFilter.CLOSE ? 'active' : ''}
              onClick={() => handleStatusChange(StatusFileFilter.CLOSE)}>
              Closed Files
            </ButtonCustom>
          </Stack>
          <Stack direction={'row'} gap={1.25}>
            {selectedStatus !== StatusFileFilter.CLOSE && (
              <>
                <ButtonFilter
                  isFiltering={
                    !(
                      !formValue.doorKnock &&
                      !formValue.earlyMorning &&
                      !formValue.status.length &&
                      !formValue.types.length
                    )
                  }
                  onClick={handleOpen}
                />
                {search ? (
                  <IconButtonStyled onClick={handleCancel}>
                    <img src={'/icons/icon_cancel_bold.svg'} alt={'icon-cancel'} />
                  </IconButtonStyled>
                ) : (
                  <IconButtonStyled onClick={() => setSearch(!search)}>
                    <img src={'/icons/icon_search.svg'} alt={'icon-search'} />
                  </IconButtonStyled>
                )}
              </>
            )}
          </Stack>
        </Stack>
        {selectedStatus !== StatusFileFilter.CLOSE && (
          <>
            {search && (
              <Box mt={2.5} mb={2}>
                <InputText
                  placeholder={'Enter your search'}
                  inputProps={{
                    defaultValue: searchInput
                  }}
                  hasInputSearch
                  onChange={handleInputSearch}
                  startAdornment={
                    <InputAdornment sx={{ marginLeft: 1.25 }} position="end">
                      <img alt={'search'} src={'/icons/icon_search.svg'} />
                    </InputAdornment>
                  }
                />
              </Box>
            )}
          </>
        )}
      </Box>

      <DialogConfirm
        onSubmit={onDeleteCloseFile}
        onClose={() => {
          setFileCloseDelete(null);
          setReason('');
        }}
        isOpen={!!fileCloseDelete}
        textTitle="Confirm Deletion"
        textContent="Are you sure you want to delete this file? This action cannot be undone."
        textButton="Delete"
        contentStyle={{ textAlign: 'center' }}
      />

      <Stack maxWidth={'100%'} mt={search ? 0 : 2.5}>
        {selectedStatus === StatusFileFilter.CLOSE ? (
          <TableInfiniteScroll
            handleChooseRow={() => {}}
            data={renderDataCloseFileTable({
              rows: closeFileData.rows,
              onDelete: setFileCloseDelete
            })}
            headers={defaultHeadersClose}
            handleFetchMore={fetchMoreCloseFileData}
            hasMore={closeFileData.hasMore}
            infoStickies={infoStickies}
            idElementScroll={widthScreen < 800 ? 'scrollableDiv' : 'scrollableDiv-web'}
          />
        ) : (
          <TableInfiniteScroll
            onSortHeader={onSortHeader}
            handleChooseRow={handleClickRow}
            data={renderDataMapFileTable(rows)}
            headers={headerTableFile()}
            handleFetchMore={fetchMoreData}
            hasMore={hasMore}
            infoStickies={infoStickies}
            idElementScroll={widthScreen < 800 ? 'scrollableDiv' : 'scrollableDiv-web'}
          />
        )}
      </Stack>
      <FilterModal
        isShowChecked
        isShowStatus
        value={formValue}
        open={open}
        onClose={handleClose}
        onReset={handleResetFilter}
        onSubmit={onFilter}
      />
    </Stack>
  );
}

export default HomePage;

const TitleStyled = styled(Typography)(({ theme }: StyledParams) => ({
  fontSize: 20,
  fontWeight: 700,
  lineHeight: '25px',
  marginTop: theme.spacing(4)
}));

const IconButtonStyled = styled(IconButton)(() => ({
  border: '1px solid #22374A',
  borderRadius: 5,
  height: 36,
  width: 36,
  '&:hover': {
    backgroundColor: 'white',
    opacity: 0.8
  }
}));

const ButtonCustom = styled(SubmitButton)(({ active }: { active?: string }) => ({
  borderRadius: 5,
  textTransform: 'none',
  paddingLeft: 10,
  paddingRight: 10,
  height: 36,
  background: active ? '#22374A' : 'white',
  color: active ? 'white' : '#22374A',
  border: active ? 'none' : '1px solid #E9EAEB',
  '&:hover': {
    backgroundColor: active ? '#22374A' : 'white',
    opacity: 0.8
  }
}));
